module.exports = __webpack_public_path__ + "static/season1-cover-750px-a62ac0891dd185d21fb8ec5d8ba37f19.jpg";